// eslint-disable-next-line import/prefer-default-export
export const ManualTypeOptions = [
  { label: "Generic", value: "0" },
  { label: "Generic 50 mm", value: "1" },
  { label: "Assembly", value: "2" },
  { label: "Assembly limited TOC", value: "3" },
  { label: "Assembly '3C'", value: "4" }
];
